import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Confirm } from 'semantic-ui-react';

import { Column } from 'components/Layout';
import LiveIdRequestService from 'shared/services/api/liveIdRequest';

export class LiveId extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canClick: (!this.props.anagrafica || (this.props.liveIdRequests.length > 0 && (
        this.props.liveIdRequests[0].state === 0 || this.props.liveIdRequests[0].state === 1 || this.props.liveIdRequests[0].state === 2))),
      showConfirm: false,
    };
  }

  componentDidUpdate({ loading }) {
    if (loading !== this.props.loading && !this.props.loading) {
      const canClick = (!this.props.anagrafica || (this.props.liveIdRequests.length > 0 && (
        this.props.liveIdRequests[0].state === 0 || this.props.liveIdRequests[0].state === 1 || this.props.liveIdRequests[0].state === 2)));
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ canClick });
    }
  }

  sendRequest = () => {
    this.props.setSubmitting(true);

    const payload = {
      anagrafica: this.props.anagrafica,
    };

    LiveIdRequestService.create(payload)
      .then(() => {
        this.props.notification.addNotification({
          message: 'La richiesta è stata inviata con successo',
          level: 'success',
        });
        this.props.setSubmitting(false);
        this.props.close();
        this.props.update(1);
      })
      .catch(({ data: { detail } }) => {
        this.props.notification.addNotification({
          message: detail || "Si è verificato un errore, se persiste contantta l'assistenza",
          level: 'error',
        });
        this.props.setSubmitting(false);
      })
      .finally(() => this.setState({ showConfirm: false }));
  };

  render() {
    return (
      <Column width={8} textAlign="center">
        <Button
          onClick={() => this.setState({ showConfirm: true })}
          disabled={this.state.canClick}
          type="button"
          icon="video camera"
          labelPosition="right"
          primary
          content="Riconoscimento remoto"
        />

        <Confirm
          size="tiny"
          content="Sei sicuro di voler procedere con il riconoscimento remoto?"
          open={this.state.showConfirm}
          cancelButton="Annulla"
          confirmButton="Conferma"
          onCancel={() => this.setState({ showConfirm: false })}
          onConfirm={() => this.sendRequest()}
        />
      </Column>
    );
  }
}

LiveId.propTypes = {
  anagrafica: PropTypes.string,
  notification: PropTypes.object,
  loading: PropTypes.bool,
  liveIdRequests: PropTypes.array,
  close: PropTypes.func,
  setSubmitting: PropTypes.func,
  update: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/LiveId/index.js